import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DeviceListItem} from "../../devices/shared/models/device-list.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DeviceService} from "../../devices/shared/services/device.service";
import {downloadPdfFromBase64} from "../../shared/utils/pdf";
import {TranslateService} from "@ngx-translate/core";

interface DialogData {
  pdfs: DeviceListItem[];
  sztExtDeviceId: string;
}

@Component({
  selector: 'app-pdf-selection-dialog',
  template: `
    <h2 mat-dialog-title>{{ 'pdf.title' | translate }} ({{ data.sztExtDeviceId }}):</h2>
    <mat-dialog-content style="max-height: 400px; overflow-y: auto;">
      <mat-selection-list #pdfList [multiple]="false">
        <mat-list-option *ngFor="let pdf of filteredPdfs" [value]="pdf.pdfId">
          {{ pdf.sztExtDeviceId }} ({{ pdf.createdTimestamp | date:'yyyy-MM-dd' }})
        </mat-list-option>
      </mat-selection-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button
              (click)="onDownload()"
              [disabled]="isDownloading"
      >
        {{ 'button.datasheet-creator' | translate }}
      </button>
      <button mat-button mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-button
              [mat-dialog-close]="pdfList.selectedOptions.selected[0]?.value"
              [disabled]="!pdfList.selectedOptions.selected.length">
        {{ 'button.download' | translate }}
      </button>
    </mat-dialog-actions>
  `
})

export class PdfSelectionDialogComponent {
  filteredPdfs: DeviceListItem[] = [];
  isDownloading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pdfs: any[], sztExtDeviceId: string },
    public dialogRef: MatDialogRef<PdfSelectionDialogComponent>,
    private readonly snackBar: MatSnackBar,
    private readonly deviceService: DeviceService,
    protected translate: TranslateService
  ) {
    this.filteredPdfs = data.pdfs.filter(pdf =>
      pdf.sztExtDeviceId === data.sztExtDeviceId
    );
  }

  onDownload(): void {
    if (!this.data.sztExtDeviceId) return;

    this.isDownloading = true;
    this.snackBar.open('Downloading...', '', {
      duration: 3000,
    });

    this.deviceService.getDeviceDatasheetLinkInstantly(this.data.sztExtDeviceId)
      .subscribe({
      next: (response) => {
        downloadPdfFromBase64(response.encodedPdf, this.data.sztExtDeviceId, true);
        this.snackBar.open(this.translate.instant('datasheet-success'), '', {
          duration: 2000
        });
      },
      error: (error) => {
        console.error('Download error:', error);
        this.isDownloading = false;
        this.snackBar.open(this.translate.instant('datasheet-error'), '', {
          duration: 2000,
        });
      },
      complete: () => {
        this.isDownloading = false;
        //this.dialogRef.close();
      }
    });
  }
}
